export const SET_SELECTED_HOTEL = 'searchResultsMap/SET_SELECTED_HOTEL';
export const MAP_MOVED = 'searchResultsMap/MAP_MOVED';
